<template>
  <div class="container-fluid main">
    <div class="row header">
      <img src="../assets/logo.png"/>
    </div>
    <div class="body">
      <div class="card-body">
        <div class="title">保函查询系统</div>
        <div class="content row">
          <div class="col-6">
            <div class="leftBox">
              <div class="form-inline line">
                <label class="label" for="guaranteeNum">保函编号</label>
                <input id="guaranteeNum" type="text" class="form-control input" v-model="guaranteeNum" />
              </div>
                <div class="form-inline line">
                  <label class="label" for="guaranteeBarcode">保函条码</label>
                  <input id="guaranteeBarcode" type="text" class="form-control input" v-model="guaranteeBarcode" />
                </div>
                <div class="form-inline line">
                  <label class="label" for="guaranteeSecurityCode">保函防伪码</label>
                  <input id="guaranteeSecurityCode" type="text" class="form-control input" v-model="guaranteeSecurityCode" />
                </div>
                <div class="form-group">
                  <button type="button" class="btn btn-primary queryBtn" @click="query">查询</button>
                </div>
            </div>
          </div>
          <div class="col-6" style="padding: 0px;">
            <div class="rightBox">
              <div class="rightText">本系统提供担保机构出具保函的真伪验证查询</div>
              <div class="rightText">查询方法：</div>
              <div class="rightText">&#12288;&#12288;1.将保函编号、保函条码及防伪码填入左侧输入框内，点击查询即可</div>
              <div class="rightText">&#12288;&#12288;2.扫描保函右上角二维码查验</div>
              <div class="rightText">对查询结果若有异议，请联系各业务经办项目经理或担保机构。</div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="row bottom">
      <div class="bottomText">晋ICP备2022005121号-1 &#12288;&#12288;&#12288;&#12288;山西嘉泰工程担保有限公司版权所有</div>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        guaranteeNum: "",
        guaranteeSecurityCode: "",
        guaranteeBarcode: "",
      }
    },
    methods:{
      query() {
        this.$router.push({name: 'pcRes', params: {barCode: this.guaranteeBarcode, secCode: this.guaranteeSecurityCode, num: this.guaranteeNum, type: "jt"}});
      }
    }
  }
</script>

<style scoped>
  .main {
    height: 624px;
    width: 1100px;
    background-image: url(src/assets/background.jpg);
    background-size: cover;
    font-family: "microsoft yahei";
  }

  .header {
    background-color: rgb(255, 255, 255, 0.5);
    height: 40px;
  }

  .header img {
     height: 100%;
     margin-left: 190px;
  }

  .bottom {
    background-color: white;
    opacity: 0.5;
    height: 30px;
    width: 100%;
    position: fixed;
    bottom: 0;
  }

  .bottomText {
    text-align: center;
    width: 100%;
    font-size: 10px;
    line-height: 30px;
  }

  .body {
    margin-top: 10%;
    height: 50%;
    width: 100%;
  }

  .card-body {
    height: 350px;
    margin-left: 180px;
    width: 750px;
    max-width: 1200px;
    background-color: rgba(255, 255, 255, 0.85);
    border-radius: 5px;
    padding: 10px;
  }

  .titleRow {
    text-align: center;
  }

  .title {
    font-size: 22px;
    font-weight: 800;
    color:#007BFF;
  }

  .content {
    height: 90%;
  }

  .leftBox {
    margin-top: 10%;
    height: 70%;
  }

  .line{
    width: 95%;
    height: 50px;
    margin: 5px;
    align-items: center;
    justify-content: center;
  }

  .label {
    font-size: 16px;
    line-height: 30px;
    width: 30%;
  }

  .input {
    width: 55%;
    height: 30px;
    padding: 2px;
    border-radius: 2px;
    font-size: 12px;
  }

  .input:focus {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  }

  .seq {
    height: 100%;
    margin-top: 2%;
  }

  .rightBox {
    margin-top: 5%;
    height: 70%;
    text-align: left;
    border-left: 1px dashed #CCC;
    padding: 20px;
  }

  .queryBtn {
    width: 70%;
    background-color: #0069d9;
    height: 40px;
    font-size: 15px;
    padding: 0px;
    margin-top: 20px;
    border-radius: 5px;
  }

  .rightText {
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 10px;
  }

 .btn:focus,
 .btn:active:focus,
 .btn.active:focus,
 .btn.focus,
 .btn:active.focus,
 .btn.active.focus {
     outline: none !important;
     box-shadow:none !important;
 }

</style>



// WEBPACK FOOTER //
// src/views/index.vue